import Logger from "../lib/logger";
import Lottie from "lottie-web";

const animationJson = require('../lottie/flowers.json');

class ThemeScreensaver {
	NAME = 'ThemeScreensaver';

	constructor(dom) {
		this.dom = dom;
		this.animation;
		this.animationDom = this.dom.querySelector(`[data-theme-screensaver-animation]`);
		this.animationDelay = (1000 * 60 * 5);
		this.animationTimer;
	}

	/**
	 * Class static initialization block
	 */
	init() {
		Logger.info(`${this.NAME} > init`);
		this.initAnimation();
	}

	// https://github.com/airbnb/lottie-web
	initAnimation() {
		Logger.info(`${this.NAME} > initAnimation`);

		if (!this.animationDom) return;

		const self = this;

		document.addEventListener(`mousemove`, e => {
			self.resetTimer();
		});
		this.resetTimer();
	}

	destroyAnimation() {
		// Logger.info(`${this.NAME} > destroyAnimation`);
		this.animation?.destroy();
		this.animation = null;
	}

	playAnimation() {
		Logger.info(`${this.NAME} > playAnimation`);

		if (this.animation) return;

		this.animation = Lottie.loadAnimation({
			container: this.animationDom, // the dom element
			renderer: 'svg',
			loop: false,
			autoplay: true,
			animationData: animationJson, // the animation data
		});
	}

	resetTimer() {
		// Logger.info(`${this.NAME} > resetTimer`);
		const self = this;
		this.destroyAnimation();
		clearTimeout(this.animationTimer);
		this.animationTimer = setTimeout(() => {
			self.playAnimation();
		}, this.animationDelay);
	}
}

export default ThemeScreensaver;
